<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit-condition-confirm">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w440">
            <div class="c-title__text c-title__text--blue u-fs34">
              配信中カートプッシュの確認
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュ名
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.message_name }}
                </div>
              </div>
              <div
                v-if="messageGroupName"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  グループ名
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ messageGroupName }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュ対象
                </div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li
                      v-if="message.service_type == 2"
                      class="c-tag-list__item c-tag-list__item--green"
                    >
                      ブラウザ
                    </li>
                    <li
                      v-if="message.service_type == 4"
                      class="c-tag-list__item c-tag-list__item--green"
                    >
                      カート
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--preview"
          >
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24">配信内容</div>
              <div class="c-text u-fs--s">
                実際の配信メッセージと表示が異なることがあります
              </div>
            </div>
            <div class="p-message-preview-list">
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">
                    PCでの配信例
                  </div>
                </div>
                <div class="p-message-preview__message-title">
                  <div class="c-text u-text-bold">
                    1回目に配信するメッセージ
                  </div>
                </div>
                <!-- プレビュー: PC -->
                <message-preview
                  :title="message.cart_title_first"
                  :text="message.cart_message_first"
                  :url="message.click_url"
                  :icon-url="message.image_url"
                />
                <template v-if="message.cart_title_second">
                  <div
                    class="p-message-preview__message-title"
                  >
                    <div class="c-text u-text-bold">
                      2回目に配信するメッセージ
                    </div>
                  </div>
                  <!-- プレビュー: PC -->
                  <message-preview
                    :title="message.cart_title_second"
                    :text="message.cart_message_second"
                    :url="message.click_url"
                    :icon-url="message.image_url"
                  />
                </template>
                <template v-if="message.cart_title_third">
                  <div
                    class="p-message-preview__message-title"
                  >
                    <div class="c-text u-text-bold">
                      3回目に配信するメッセージ
                    </div>
                  </div>
                  <!-- プレビュー: PC -->
                  <message-preview
                    :title="message.cart_title_third"
                    :text="message.cart_message_third"
                    :url="message.click_url"
                    :icon-url="message.image_url"
                  />
                </template>
              </div>
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">
                    スマホでの配信例
                  </div>
                </div>
                <div class="p-message-preview__message-title">
                  <div class="c-text u-text-bold">
                    1回目に配信するメッセージ
                  </div>
                </div>
                <message-preview-sp
                  :title="message.cart_title_first"
                  :text="message.cart_message_first"
                  :url="message.click_url"
                  :icon-url="message.image_url"
                />
                <template v-if="message.cart_title_second">
                  <div
                    class="p-message-preview__message-title"
                  >
                    <div class="c-text u-text-bold">
                      2回目に配信するメッセージ
                    </div>
                  </div>
                  <message-preview-sp
                    :title="message.cart_title_second"
                    :text="message.cart_message_second"
                    :url="message.click_url"
                    :icon-url="message.image_url"
                  />
                </template>
                <template v-if="message.cart_title_third">
                  <div
                    class="p-message-preview__message-title"
                  >
                    <div class="c-text u-text-bold">
                      3回目に配信するメッセージ
                    </div>
                  </div>
                  <message-preview-sp
                    :title="message.cart_title_third"
                    :text="message.cart_message_third"
                    :url="message.click_url"
                    :icon-url="message.image_url"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--details"
          >
            <div class="c-title">
              <div class="c-title__text u-fs24">配信設定</div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  utmクエリ
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.utm_query }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  1回目の配信
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.cart_work_hours_first }}時間後
                </div>
              </div>
              <div
                v-if="message.cart_work_hours_second != null"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  2回目の配信
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.cart_work_hours_second }}時間後
                </div>
              </div>
              <div
                v-if="message.cart_work_hours_third != null"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  3回目の配信
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ message.cart_work_hours_third }}時間後
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  配信しない時間帯
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ nonWorkingHours }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend"></div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--red u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingStopBtn, 'is-completed': isCompleteMessage }"
            :disabled="isLoadingStopBtn || isCompleteMessage"
            type="button"
            name="next"
            value="next"
            @click="onStopClick()"
          >
            <p class="c-btn__text">配信を停止する</p>
          </button>
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p class="c-btn__text">配信メッセージの一覧に戻る</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: 配信設定・配信停止完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="メッセージ一覧へ"
      :can-click-outside=false
      :is-active="isCompleteMessage"
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active="isError"
      :message="errorMessage"
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    breadcrumbData: Array,
    csrfToken: String,
    message: Object,
  },
  data() {
    return {
      completeMessage: '',
      errorMessage: '',
      isCompleteMessage: false,
      isError: false,
      isLoadingStopBtn: false,
    };
  },
  computed: {
    messageGroupName() {
      return this.getMessageGroupName();
    },
    nonWorkingHours() {
      return this.message.cart_non_working_start_hours === null &&
        this.message.cart_non_working_end_hours === null
        ? 'なし'
        : `${this.message.cart_non_working_start_hours}時 〜 ${this.message.cart_non_working_end_hours}時`;
    },
  },
  mounted: function () {
    import('../../funcs/pages/message-add-condition').then((module) => {
      module.MessageAddCondition();
    });
  },
  methods: {
    onBackClick: function () {
      location.href = '/coins-admin/message';
    },
    getMessageGroupName: function () {
      return this.message.message_group_message?.message_group
        ?.group_name;
    },
    onStopClick: function () {
      // ローディング表示設定, ボタン無効化設定
      this.isLoadingStopBtn = true;

      // 設定用パラメタ作成
      const params = {
        message_id: this.message.message_id,
      };

      axios
        .post('/api/message/stop', params)
        .then((res) => {
          if (this.handleResponse(res)) {
            this.completeMessage =
              'プッシュ通知の配信停止が完了しました。';
            this.isCompleteMessage = true;
          } else {
            this.isError = true;
            this.errorMessage =
              res && res.data && res.data.message
                ? res.data.message
                : 'プッシュ通知の配信停止に失敗しました';
          }
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingStopBtn = false;
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'プッシュ通知の配信停止に失敗しました';
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingStopBtn = false;
          }, 300);
        });
    },

    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onCloseControlModal() {
      this.isCompleteMessage = false;
      location.href = '/coins-admin/message';
    },
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = '/coins-admin/message';
    },
  },
};
</script>
